import { TFunction } from 'i18next';
import {
  LinearChart,
  Timer,
  DocumentTextOutline,
  Notes,
  Search,
  ProfileUserOutline,
  LinearBriefcase,
  LinearReceipt,
  LinearNoteAdd,
  FilledLinearGraph,
  TimerFilled,
  DocumentText,
  FilledNote,
  SearchFilled,
  ProfileUser,
  Briefcase,
  Receipt,
  NoteAdd,
} from '../components/icons';
import { FeatureSelectionTab, IFeature } from '../interface/featureSelection';

const FEATURE_ICON_CLASS = 'fz-20 text-clr-general-primary flex-shrink-0';

export const getFeatureRows = (t: TFunction, isRestrictedUser: boolean): IFeature[] => [
  {
    id: FeatureSelectionTab.dashboard,
    icon: <LinearChart className={FEATURE_ICON_CLASS} />,
    selectedIcon: <FilledLinearGraph className={FEATURE_ICON_CLASS} />,
    text: t('common:tab.dashboard'),
    disabled: true,
    defaultChecked: true,
  },
  {
    id: FeatureSelectionTab.timer,
    icon: <Timer className={FEATURE_ICON_CLASS} />,
    selectedIcon: <TimerFilled className={FEATURE_ICON_CLASS} />,
    text: t('common:timers.timer'),
    disabled: true,
    defaultChecked: true,
  },
  {
    id: FeatureSelectionTab.transactions,
    icon: <DocumentTextOutline className={FEATURE_ICON_CLASS} />,
    selectedIcon: <DocumentText className={FEATURE_ICON_CLASS} />,
    text: t('common:tab.transactions'),
    disabled: true,
    defaultChecked: true,
  },
  {
    id: FeatureSelectionTab.tasks,
    icon: <Notes className={FEATURE_ICON_CLASS} />,
    selectedIcon: <FilledNote className={FEATURE_ICON_CLASS} />,
    text: t('common:features.tasksCriticalTasks'),
    disabled: false,
  },
  {
    id: FeatureSelectionTab.conflictSearch,
    icon: <Search className={FEATURE_ICON_CLASS} />,
    selectedIcon: <SearchFilled className={FEATURE_ICON_CLASS} />,
    text: t('common:mainHeader.conflictSearch'),
    disabled: false,
    hide: isRestrictedUser,
  },
  {
    id: FeatureSelectionTab.customers,
    icon: <ProfileUserOutline className={FEATURE_ICON_CLASS} />,
    selectedIcon: <ProfileUser className={FEATURE_ICON_CLASS} />,
    text: t('common:tab.customers'),
    disabled: false,
  },
  {
    id: FeatureSelectionTab.matters,
    icon: <LinearBriefcase className={FEATURE_ICON_CLASS} />,
    selectedIcon: <Briefcase className={FEATURE_ICON_CLASS} />,
    text: t('common:tab.matters'),
    disabled: false,
  },
  {
    id: FeatureSelectionTab.invoicing,
    icon: <LinearReceipt className={FEATURE_ICON_CLASS} />,
    selectedIcon: <Receipt className={FEATURE_ICON_CLASS} />,
    text: t('common:features.myInvoicing'),
    disabled: false,
    hide: isRestrictedUser,
  },
  {
    id: FeatureSelectionTab.workTimes,
    icon: <LinearNoteAdd className={FEATURE_ICON_CLASS} />,
    selectedIcon: <NoteAdd className={FEATURE_ICON_CLASS} />,
    text: t('common:tab.worktimes'),
    disabled: false,
  },
];
